import { CampaignEndpoint } from "@/views/loyalty/shared/endpoint_services/campaign-endpoint-service"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"

export class CampaignService {
    constructor () {
        this.campaignEndpoint = new CampaignEndpoint()
    }

    createCampaign (campaign) {
        return this.campaignEndpoint.create_campaign(campaign)
    }

    async deleteCampaign (campaignId) {
        return this.campaignEndpoint.delete_campaign(campaignId)
    }

    async getAllCampaigns (page, limit, filter, search) {
        return this.campaignEndpoint.read_campaigns(page || 1, limit || -1, filter || [], search || SearchStuffModel)
        // return campaign.items, campaign.count
    }

    async getCampaignsByCustomerId (customerId, page, limit, filter, search) {
        return this.campaignEndpoint.read_campaigns_by_customerId(customerId, page || 1, limit || -1, filter || [], search || SearchStuffModel)
    }
}
